import React, { FC, memo } from 'react'
import { EFeatureFlags } from 'astra-core/containers/ConfigProvider/types'

import { Auth } from 'widgets/Auth/Auth'
import { RightBasketContainer } from 'containers/BasketContainer'
import { NotificationsPanel } from 'widgets/notifications-panel'
import { Header } from 'widgets/header'
import { CalendarMenu } from 'widgets/calendar-menu'
import { FooterOfPage } from 'widgets/footer-of-page'
import { HeaderCalendar } from 'pages/page-calendar/CalendarEvents/components/Header'
import { HeaderCalendar as HeaderCalendarV2 } from 'pages/calendar/ui/Header'
import { CalendarMenuV2 } from 'widgets/calendar-menu-v2'
import { useAppFeatureFlag } from 'shared/config'

import { LayoutProps } from '../../Layout.types'

import { StyledContent, StyledLayout } from './Calendar.styled'

export const LayoutCalendar: FC<LayoutProps> = memo(({ children }) => {
  const virtualScrollEnabled = useAppFeatureFlag(
    EFeatureFlags.NEW_EVENTS_ENDPOINT
  )
  const isNewCountersEndpoint = useAppFeatureFlag(
    EFeatureFlags.NEW_COUNTERS_ENDPOINT
  )
  return (
    <StyledLayout>
      <Auth />

      <Header />

      {virtualScrollEnabled ? <HeaderCalendarV2 /> : <HeaderCalendar />}

      {isNewCountersEndpoint ? <CalendarMenuV2 /> : <CalendarMenu />}

      <NotificationsPanel />

      <StyledContent>
        {children}
        <FooterOfPage />
      </StyledContent>

      <RightBasketContainer />
    </StyledLayout>
  )
})
